export const stripTimezoneFormat = (format: string) => format.replace(/x/g, '').trim();
